function isStringEqual(actual, expected) {
  return actual.toLowerCase() === expected.toLowerCase();
}
export {
  isStringEqual
};
//# sourceMappingURL=isStringEqual.mjs.map